import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accessability',
  templateUrl: './accessability.component.html',
  styleUrls: ['./accessability.component.scss']
})
export class AccessabilityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/accessability/accessability.component.ts